module.exports = __webpack_public_path__ + "static/media/WS.197f96e9.svg";